module.exports = __webpack_public_path__ + "static/miss-monique_1-380c26d28270e20df674014dbb2c96cd.jpg";